import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { PersonalInformation } from './personal-information';
export { PersonalInformation };
import { personalInformationSchema } from '@schemas/business-objects/personal-information';
import { CandidateFormGroup } from './candidate-form-group';

export class PersonalInformationFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    lastName: SchemaFormControl;
    firstName: SchemaFormControl;
    patronymic: SchemaFormControl;
    dateOfBirth: SchemaFormControl;
    gender: SchemaFormControl;
    countryOfBirth: SchemaFormControl;
    cityOfBirth: SchemaFormControl;
    countryOfResidence: SchemaFormControl;
    citizenship: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
  };

  declare value: Partial<PersonalInformation>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(personalInformationSchema, PersonalInformation, data, options);
  }

  get object(): PersonalInformation {
    return new PersonalInformation(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      default:
        return undefined;
    }
  }
}

export class PersonalInformationFormArray extends PersistedFormArray {
  readonly entityName = 'PersonalInformation' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(personalInformationSchema, PersonalInformation, options);
  }

  protected override createItemGroup() {
    return new PersonalInformationFormGroup();
  }

  get array(): PersonalInformation[] {
    return this.controls.map(
      (group: PersonalInformationFormGroup) => group.object,
    );
  }
}

export class PersonalInformationPersistedArray extends PersistedArray<PersonalInformation> {
  readonly entityName = 'PersonalInformation' as const;

  constructor(options?: PersistedArrayOptions) {
    super(PersonalInformation, options);
  }
}
